(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/utils/assets/javascripts/wager-presentation.js') >= 0) return;  svs.modules.push('/components/pool-betting/utils/assets/javascripts/wager-presentation.js');
"use strict";

var _svs;

const _ref = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.moduleBuilder) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.myBets) || {},
  _ref$multiDrawsSystem = _ref.multiDrawsSystemTextLobby,
  multiDrawsSystemTextLobby = _ref$multiDrawsSystem === void 0 ? '' : _ref$multiDrawsSystem;
const _svs$components$sport = svs.components.sport.tipsenShared.constants,
  SystemTypePresentation = _svs$components$sport.SystemTypePresentation,
  WagerSystemTypes = _svs$components$sport.WagerSystemTypes;
const formatCurrency = svs.utils.format.Currency;
const productIds = svs.utils.products.productIds;
const composeWagerDescription = _ref2 => {
  let productId = _ref2.productId,
    description = _ref2.description,
    systemType = _ref2.systemType,
    isCompetitionWager = _ref2.isCompetitionWager,
    isUserBoards = _ref2.isUserBoards,
    rowCount = _ref2.rowCount;
  let processedDescription = '';
  if (productId === productIds.BOMBEN) {
    if (systemType === WagerSystemTypes.RSYS) {
      processedDescription = "Reducerat ".concat(description);
    } else {
      processedDescription = description;
    }
  } else {
    processedDescription = description;
    if (systemType === WagerSystemTypes.MSYS) {
      processedDescription = isCompetitionWager || isUserBoards ? "M-system (".concat(rowCount, " st)") : "".concat(rowCount, " rader");
    }
  }
  if (typeof processedDescription === 'string' && processedDescription.includes(rowCount.toString())) {
    processedDescription = processedDescription.replace(rowCount.toString(), formatCurrency(rowCount.toString()));
  }
  return processedDescription;
};
const getIconBySystemType = _ref3 => {
  var _SystemTypePresentati;
  let isCompetitionWager = _ref3.isCompetitionWager,
    isGroup = _ref3.isGroup,
    isUserBoards = _ref3.isUserBoards,
    groupName = _ref3.groupName,
    productId = _ref3.productId,
    rowCount = _ref3.rowCount,
    systemType = _ref3.systemType,
    multiDraw = _ref3.multiDraw;
  if (isCompetitionWager) {
    return 'trophy-tips-sm';
  }
  if (isGroup || groupName) {
    return 'spela-tillsammans';
  }
  const totalDrawCount = multiDraw.totalDrawCount,
    completedDrawCount = multiDraw.completedDrawCount;
  if (totalDrawCount && totalDrawCount > 1 && totalDrawCount !== completedDrawCount) {
    return 'calendar';
  }
  if (productId === productIds.BOMBEN) {
    if (rowCount === 1 && systemType !== WagerSystemTypes.RSYS) {
      return SystemTypePresentation.MSYS.icon;
    }
    if (systemType === WagerSystemTypes.SROW && !isUserBoards) {
      return SystemTypePresentation.PIX.icon;
    }
  }
  return (_SystemTypePresentati = SystemTypePresentation[systemType]) === null || _SystemTypePresentati === void 0 ? void 0 : _SystemTypePresentati.icon;
};
const getSystemType = _ref4 => {
  var _boards$betProperties, _boards$betProperties2;
  let productId = _ref4.productId,
    _ref4$boards = _ref4.boards,
    boards = _ref4$boards === void 0 ? {} : _ref4$boards;
  if ((_boards$betProperties = boards.betProperties) !== null && _boards$betProperties !== void 0 && _boards$betProperties.includes(WagerSystemTypes.REDUCERA_FRITT)) {
    return WagerSystemTypes.REDUCERA_FRITT;
  }

  if (productId === productIds.BOMBEN && (_boards$betProperties2 = boards.betProperties) !== null && _boards$betProperties2 !== void 0 && _boards$betProperties2.includes(WagerSystemTypes.XPERTEN)) {
    return WagerSystemTypes.SROW;
  }
  return boards.systemType;
};
const getTextBySystemType = _ref5 => {
  var _SystemTypePresentati2;
  let competitionDesc = _ref5.competitionDesc,
    groupId = _ref5.groupId,
    isCompetitionWager = _ref5.isCompetitionWager,
    isGroup = _ref5.isGroup,
    isUserBoards = _ref5.isUserBoards,
    marketplaceGroups = _ref5.marketplaceGroups,
    multiDraw = _ref5.multiDraw,
    productId = _ref5.productId,
    rowCount = _ref5.rowCount,
    systemType = _ref5.systemType;
  const totalDrawCount = multiDraw.totalDrawCount,
    completedDrawCount = multiDraw.completedDrawCount;
  if (isCompetitionWager && competitionDesc) {
    return competitionDesc !== null && competitionDesc !== void 0 ? competitionDesc : 'Tävling';
  }
  if (isGroup && marketplaceGroups !== null && marketplaceGroups !== void 0 && marketplaceGroups.isSuccess) {
    var _correctGroup$;
    const correctGroup = [];
    marketplaceGroups === null || marketplaceGroups === void 0 || marketplaceGroups.data.forEach(group => {
      if (group.groupId === groupId) {
        correctGroup.push(group);
      }
    });
    if ((_correctGroup$ = correctGroup[0]) !== null && _correctGroup$ !== void 0 && _correctGroup$.name) {
      return correctGroup[0].name;
    }
    return 'Spela tillsammans';
  } else if (isGroup && marketplaceGroups !== null && marketplaceGroups !== void 0 && marketplaceGroups.isError) {
    return 'Spela tillsammans';
  }
  if (isGroup && marketplaceGroups !== null && marketplaceGroups !== void 0 && marketplaceGroups.isError) {
    return 'Spela tillsammans';
  }
  if (isUserBoards) {
    return 'Externa systemspel';
  }
  if (totalDrawCount && totalDrawCount > 1) {
    if (totalDrawCount !== completedDrawCount) {
      const currentWeek = completedDrawCount + 1;
      return "".concat(multiDrawsSystemTextLobby, " (").concat(currentWeek, " av ").concat(totalDrawCount, ")");
    }
    if (totalDrawCount === completedDrawCount) {
      return multiDrawsSystemTextLobby;
    }
    return multiDrawsSystemTextLobby;
  }
  if (productId === productIds.BOMBEN || productId === productIds.MATCHEN) {
    if (systemType === WagerSystemTypes.RSYS) {
      return 'Reducerat';
    }
    if (rowCount === 1) {
      return SystemTypePresentation.MSYS.text;
    }
    if (systemType === WagerSystemTypes.SROW) {
      return SystemTypePresentation.PIX.text;
    }
  }
  return (_SystemTypePresentati2 = SystemTypePresentation[systemType]) === null || _SystemTypePresentati2 === void 0 ? void 0 : _SystemTypePresentati2.text;
};
setGlobal('svs.components.poolBetting.utils.wagerPresentation', {
  composeWagerDescription,
  getIconBySystemType,
  getSystemType,
  getTextBySystemType
});

 })(window);